module.exports = __webpack_public_path__ + "static/media/image15-example.5d9323cb.jpg";